import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var IdmsLogoIcon = function IdmsLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 38 38' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: viewBox
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M32.0078341,5.49216592 C39.330722,12.8150538 39.330722,24.6862143 32.0078341,32.0091022 C24.6849462,39.3302993 12.8137857,39.3302993 5.49089782,32.0091022 C-1.83029927,24.6862143 -1.83029927,12.8150538 5.49089782,5.49216592 C12.8137857,-1.83072197 24.6849462,-1.83072197 32.0078341,5.49216592 Z M27.4340303,12.4816266 C27.1432114,12.3818689 26.8337936,12.4528828 26.619061,12.6676154 L26.619061,12.6676154 L12.4923632,26.7943133 C12.186327,27.1003494 12.186327,27.5974469 12.4923632,27.9034831 C13.0063687,28.4174886 13.681001,28.6744913 14.3539424,28.6744913 C15.0285746,28.6744913 15.7032069,28.4174886 16.2172124,27.9034831 L16.2172124,27.9034831 L24.8200417,19.3023446 L27.5473144,22.0296173 C27.7857183,22.2680212 28.1374063,22.3288903 28.4434425,22.18179 C28.7477879,22.0346897 28.9202502,21.7218903 28.8830525,21.3871104 L28.8830525,21.3871104 L27.9531083,13.1359691 C27.9192921,12.8333145 27.7197768,12.583075 27.4340303,12.4816266 Z M24.8026264,9.51172293 C23.8895903,8.596996 22.4016795,8.596996 21.4886434,9.51172293 L21.4886434,9.51172293 L12.6812264,18.3191399 L9.95226286,15.5901764 C9.71385899,15.3517725 9.362171,15.2909035 9.05613481,15.4396945 C8.75178944,15.585104 8.57932706,15.8979034 8.61821563,16.2343741 L8.61821563,16.2343741 L9.72907626,26.1036183 L25.561799,10.2708956 Z"
    }))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.product.idms,
        fillRule: 'evenodd'
      };
    }
  };
});